module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAABICAYAAACeNle5AAABEUlEQVRoge3aPYoCQRCG4bqBc6m5hybiFQQTYYONTJbBY24gm6zCazLCCCbbXWXVwhd8cT9M/1QNlJmZAStgBNbA9s1Zz2uvbMYMSZBXsMFmXTbmkdGKfJ1HNlYA8RSBBBJIoOwIJJBAAmVHoGzQrhJoAq7AuQJoAm7AN7DPBi0xh+wt68J4g7oxniAXjBfIDeMBcsX0gtwxPaAQTCsoDNMC+ozEtIA+gF/gAhwrgLbAKRLVeqjDUD3XPgTV+zC6ozxKhyvKq7i6oTzbDxeUd4PWjYpoYbtQUU3+EvWnEhP5G3QCfoCvKqCmCCSQQAJlRyCBBBIoOwL9S1C5gaZyI1+1huIWk3ojsMnYpnntwczsDk97WykK0wztAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/leftArrow.png
// module id = Sv2K
// module chunks = 0